import authService from './authService';

export interface UserGuideResponse {
  profile: string;
  title: string;
  permission: string;
  /** Fragmento HTML do manual (abas = <section>, tópicos = <div class="topic">). */
  html: string;
}

class UserGuideService {
  /** Manual do perfil; a API exige user_guide.<perfil> (o admin lê todos). */
  async get(profile: string): Promise<UserGuideResponse> {
    const apiClient = await authService.getApiClient();
    const response = await apiClient.get(`/user-guides/${encodeURIComponent(profile)}`);
    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.message || 'Falha ao carregar a documentação');
    }
    const json = await response.json();
    return json.data as UserGuideResponse;
  }
}

export const userGuideService = new UserGuideService();
export default userGuideService;
